// extracted by mini-css-extract-plugin
export var closeButton = "_41-3";
export var header = "_41-0";
export var link = "_41-1";
export var retryButton = "_41-2";